var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirmation-page mt-6 px-5 px-sm-1 white--text",domProps:{"innerHTML":_vm._s(_vm.staticTranslation('texts.ageConfirmation'))}})
}
var staticRenderFns = []

export { render, staticRenderFns }